import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import CustomCheckbox from '../../CustomCheckbox/CustomCheckbox'
import { useDispatch } from 'react-redux';
import { CopyTextSvg } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import { change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';

import cs from '../../../components/commonStyle.css';
import s from '../AIFeatureStyle.css';


const CopyTextBlock = ({ isCheckBox, name, isCopied, onCopy, copiedLabel, label, content, containerClass }) => {


    const dispatch = useDispatch();
    const [isChecked, setIsChecked] = useState(true);

    useEffect(() => {
        dispatch(change('ListingTitleDescriptionForm', `isTitleChanged`, true));
        dispatch(change('ListingTitleDescriptionForm', `isDescriptionChanged`, true));
    }, []);

    const handleClick = (fieldName) => {
        setIsChecked(!isChecked);
        dispatch(change('ListingTitleDescriptionForm', fieldName, !isChecked));
    };
    return (
        <div className={containerClass}>
            <div className='commonLabelText'>
                <div className='commonCustomCheckFlex'>
                    {isCheckBox &&
                        <CustomCheckbox
                            checked={isChecked}
                            onChange={() => handleClick(name)}
                            containerClassName={cs.noMargin}
                            className={cx("commonCustomCheckBox normalSizeCheckBox", cs.positionRelative, cs.top4)}
                        />}
                    {label}
                </div>
                <div className={cs.positionRelative}>
                    <CopyTextSvg onClick={onCopy} className={s.copyIcon} />
                    {isCopied && <span className={s.copyIndicateTip}>{copiedLabel}</span>}
                </div>
            </div>
            <div className={s.aiGenerateText}>{content}</div>
        </div>
    )
}

export default withStyles(cs, s)(CopyTextBlock);
